import React from 'react'

function ArrowFunction() {
  return (
    <span className='cs-data-function-arrow'>Arrow Function</span>
  )
}

export  {ArrowFunction}